import getAllowDownload from 'owa-attachment-model-store/lib/actions/initialization/getAllowDownload';
import { AttachmentPolicyInfo, getAttachmentPolicyInfo } from 'owa-attachment-policy';
import { getExtensionFromFileName } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export function isDownloadAllowed(attachment: AttachmentType) {
    const attachmentPolicyInfo: AttachmentPolicyInfo = getAttachmentPolicyInfo(
        attachment,
        true /* isWacPreviewSupportedOnPlatform */
    );
    const fileExtension = getExtensionFromFileName(attachment.Name);
    return getAllowDownload(attachmentPolicyInfo, attachment, fileExtension);
}
